import type { MtoMaterialPosition, NsiMapping } from '@entities/mto';

/** Код и наименование 1С по позиции (принятая привязка). */
export function nsiOf(m: NsiMapping | undefined): { code: string | null; name: string } | null {
  if (!m || !m.nomenclature_id || !(m.status === 'auto' || m.status === 'verified')) return null;
  const c = m.candidates.find((x) => x.nomenclature_id === m.nomenclature_id);
  return c ? { code: c.code, name: c.name } : null;
}

export function matches(p: MtoMaterialPosition, q: string): boolean {
  if (!q) return true;
  const hay = `${p.name} ${p.designation ?? ''} ${p.code ?? ''} ${p.gost ?? ''}`.toLowerCase();
  return q
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .every((w) => hay.includes(w));
}
